import * as actions from "../actions/communicationActions";

const initialState = {
  data: [],
  admins: [],
  coaches: [],
  suggestedPersons: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_TRIGGERS:
      return {
        ...state,
        data: action.data,
      };

    case actions.SET_TRIGGERS:
      return {
        ...state,
        data: action.triggers,
      };

    case actions.FETCH_ADMINS:
      return {
        ...state,
        admins: action.admins,
      };

    case actions.FETCH_COACHES:
      return {
        ...state,
        coaches: action.coaches,
      };

    case actions.SEARCH_PERSONS:
      return {
        ...state,
        suggestedPersons: action.persons,
      };

    default:
      return state;
  }
}
